import "../App.css";
import "./styles/sponsors.css";
import hopper from "../images/hoppersleepy.png";
import sponsor1 from "../images/sponsor1.png";
import sponsor2 from "../images/sponsor2.svg";
import sponsor3 from "../images/sponsor3.jpg";
import sponsor4 from "../images/sponsor4.png";
import sponsor5 from "../images/sponsor5.png";
import sponsor6 from "../images/sponsor6.png";
import sponsor7 from "../images/temp_sponsor.jpg";
import bearTBD from "../images/bear-tbd.png";
import { forwardRef } from "react";

function Sponsors(props, ref) {
  return (
    <>
      <div
        ref={ref}
        className="sponsors gradient position-relative text-white text-center w-100 display-block p-5"
        id="sponsorsbackground"
      >
        <div class="content" style={{ top: "3vw" }}>
          <div class="text-center">
            <img
              src={hopper}
              class="img-fluid"
              alt="Hopper Image"
              style={{ maxWidth: "10%" }}
            />
          </div>
          <h1 style={{ fontSize: "4vw", fontWeight: "bold" }}>SPONSORS</h1>

          {/* <div className="p-5">
            <p>Sponsors will be revealed soon!</p>
            <img
              src={bearTBD}
              alt="Hopper Image"
              style={{ maxWidth: "40%" }}
            />
          </div> */}
          <div class="container p-5">
            <div className="row">
              <div className="col-sm">
                <div className="pb-4">
                  <a href="https://mule.to/p5e8" target="_blank">
                    <img
                      src={sponsor1}
                      class="img-fluid"
                      alt="Sponsor Image"
                      style={{ maxWidth: "80%" }}
                    />
                  </a>
                </div>
              </div>

              <div className="col-sm" style={{ marginTop: "-25px" }}>
                <div className="pb-4">
                  <a href="https://www.wolfram.com" target="_blank">
                    <img
                      src={sponsor2}
                      class="img-fluid"
                      alt="Sponsor Image"
                      style={{ maxWidth: "100%" }}
                    />
                  </a>
                </div>
              </div>

              <div className="col-sm" style={{ marginTop: "20px" }}>
                <div className="pb-4" style={{ marginTop: "25px" }}>
                  <a href="https://balsamiq.com" target="_blank">
                    <img
                      src={sponsor3}
                      class="img-fluid"
                      alt="Sponsor Image"
                      style={{ maxWidth: "100%" }}
                    />
                  </a>
                </div>
              </div>

              <div className="col-sm">
                <div className="pb-4">
                  <a href="https://cloud.google.com" target="_blank">
                    <img
                      src={sponsor4}
                      class="img-fluid"
                      alt="Sponsor Image"
                      style={{ maxWidth: "100%" }}
                    />
                  </a>
                </div>
              </div>

              <div className="col-sm">
                <div className="pb-4">
                  <a href="https://www.echo3d.com" target="_blank">
                    <img
                      src={sponsor6}
                      class="img-fluid"
                      alt="Sponsor Image"
                      style={{ maxWidth: "100%" }}
                    />
                  </a>
                </div>
              </div>

              <div className="col-sm" style={{marginTop:'20px'}}>
                <div className="pb-4">
                  <a href="https://www.coca-cola.com" target="_blank">
                    <img
                      src={sponsor5}
                      class="img-fluid"
                      alt="Sponsor Image"
                      style={{ maxWidth: "100%" }}
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default forwardRef(Sponsors);
